<template>
  <div class="price-tag">
    <span class="tag">{{ tag }}</span>
    <span v-if="sub" class="tag-sub">{{ sub }}</span>
    <div class="arrow"></div>
  </div>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: ''
    },
    sub: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.price-tag {
  position: relative;
  display: inline-flex;
  max-width: 100%;
  height: 18px;
  background-color: #f03100;
  border-radius: 2px;
  text-align: center;
  line-height: 16px;
  font-weight: 500;
  font-size: 12px;
  border: 1px solid #f03100;
  margin-bottom: 1px;
  .tag {
    color: #fff;
    padding: 0 6px;
    flex: 1 1 auto;
    min-width: 0;
    @include text-overflow-ellipsis;
  }
  .tag-sub {
    color: #f03100;
    background-color: #fff;
    padding: 0 4px;
    flex: 0 0 auto; // 关键：不伸缩，内容撑开
    white-space: nowrap; // 防止换行
  }
  .arrow {
    position: absolute;
    top: 17px;
    left: 8px;
    width: 0;
    border: 5px solid transparent;
    border-top-color: #f03100;
    border-bottom: none;
  }
}
</style>
